import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { hasScreenAccess } from "../utils/screens";

/**
 * Bloqueia o acesso direto (via URL) a uma tela que o usuário não tem permissão.
 * Caso não tenha acesso, redireciona para a home.
 */
const ScreenGuard = ({
  link,
  children,
}: {
  link: string;
  children: ReactElement;
}) => {
  const auth = useAuthUser<any>();

  if (!hasScreenAccess(auth, link)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ScreenGuard;
